'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getWorkflowConfigurationSaga = getWorkflowConfigurationSaga;

var _effects = require('redux-saga/effects');

var _reduceWorkflowConfiguration = require('../../actions/workflow/reduceWorkflowConfiguration');

var _metrixCommon = require('metrix-common');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getWorkflowConfigurationSaga);

function getWorkflowConfigurationSaga() {
    var response, result;
    return regeneratorRuntime.wrap(function getWorkflowConfigurationSaga$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.put)((0, _metrixCommon.reduceLoading)(true));

                case 2:
                    _context.prev = 2;
                    _context.next = 5;
                    return (0, _effects.call)(fetch, '/api/context/workflow-configuration', {
                        method: 'GET',
                        credentials: 'same-origin',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        }
                    });

                case 5:
                    response = _context.sent;
                    _context.next = 8;
                    return (0, _effects.call)([response, 'json']);

                case 8:
                    result = _context.sent;

                    if (!(response.ok && result.operation.status)) {
                        _context.next = 14;
                        break;
                    }

                    _context.next = 12;
                    return (0, _effects.put)((0, _reduceWorkflowConfiguration.reduceWorkflowConfiguration)(result.workflowConfiguration));

                case 12:
                    _context.next = 15;
                    break;

                case 14:
                    console.error('Failed to fetch workflow configuration:', result);

                case 15:
                    _context.next = 20;
                    break;

                case 17:
                    _context.prev = 17;
                    _context.t0 = _context['catch'](2);

                    console.error('Error fetching workflow configuration:', _context.t0);

                case 20:
                    _context.prev = 20;
                    _context.next = 23;
                    return (0, _effects.put)((0, _metrixCommon.reduceLoading)(false));

                case 23:
                    return _context.finish(20);

                case 24:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[2, 17, 20, 24]]);
}